export const PAIRING_METHOD = {
  NONE: 'none',
  PAIRING: 'pairing',
  SSI: 'ssi',
};

export const SKIP_SSI_KEY = 'skip_SSI';
